import { Activity, BarChart3, Bookmark, Compass, HardDriveDownload, Heart, History, Home, Library, ListVideo, MapPin } from 'lucide-react';
import { urls } from '@/lib/urls';

export interface NavItem {
  readonly to: string;
  readonly label: string;
  readonly icon: typeof Home;
  /** Match nested routes too, so a genre page keeps "Collections" highlighted. */
  readonly matchPrefix?: string;
  /** The viewer's own pages, gathered under one "Library" menu on wide screens. */
  readonly library?: boolean;
}

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  { to: urls.home(), label: 'Home', icon: Home },
  { to: urls.browse(), label: 'Browse', icon: Compass },
  { to: urls.terms(), label: 'Collections', icon: Library, matchPrefix: '/collections' },
  { to: urls.watchlist(), label: 'Watchlist', icon: Bookmark, library: true },
  { to: urls.lists(), label: 'Lists', icon: ListVideo, matchPrefix: '/lists', library: true },
  { to: urls.favourites(), label: 'Favourites', icon: Heart, library: true },
  { to: urls.history(), label: 'History', icon: History, library: true },
  { to: urls.bookmarks(), label: 'Bookmarks', icon: MapPin, library: true },
  { to: urls.downloads(), label: 'Downloads', icon: HardDriveDownload, library: true },
  { to: urls.stats(), label: 'Stats', icon: BarChart3 },
  { to: urls.indexing(), label: 'Indexing', icon: Activity, matchPrefix: '/indexing' },
];
